<div
  *ngIf="isVisible"
  class="tw-absolute tw-bg-white dark:tw-bg-dark-300 tw-border tw-border-gray-300 dark:tw-border-dark-100 tw-rounded-lg tw-z-10 *:sm:tw-p-4 *:tw-p-2"
  [ngClass]="
    !rightPopover
      ? '2xl:tw-right-24 sm:tw-right-[55px] tw-right-[25px]'
      : '2xl:tw-left-24 sm:tw-left-[55px] tw-left-[25px]'
  "
>
  <!-- Header -->
  <div
    class="tw-relative tw-border-b tw-border-gray-200 dark:tw-border-dark-100 tw-bg-gray-100 dark:tw-bg-dark-500 tw-pb-2 tw-rounded-t-lg"
  >
    <div class="tw-flex-between">
      <div class="tw-flex-center">
        <span
          class="!tw-text-[16px] tw-font-semibold tw-text-gray-600 dark:!tw-text-gray-200 tw-min-w-[40px]"
          >{{ "common.text" | translate }}
        </span>

        <!--* copy -->
        <i
          [title]="'common.copy' | translate"
          class="mdi mdi-content-copy tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-500 mdi-20px tw-px-2"
          (click)="copyText()"
        ></i>
      </div>

      <!--* close btn -->
      <i
        class="mdi mdi-window-close tw-text-gray-400 hover:!tw-text-red-500 mdi-20px tw-cursor-pointer"
        (click)="closePopover()"
      ></i>
    </div>

    <i
      [ngClass]="
        !rightPopover
          ? 'mdi-menu-right tw-right-[-29px]'
          : 'mdi-menu-left tw-left-[-28px]'
      "
      class="mdi mdi-48px tw-absolute tw-bottom-0 tw-text-gray-400 dark:!tw-text-dark-100 tw-top-0.5"
    ></i>
  </div>

  <!-- Body -->
  <div class="tw-pt-2 sm:tw-w-72 tw-w-60 tw-max-h-72 tw-overflow-y-auto">
    @if(isShowText){
    <p
      class="tw-text-gray-500 tw-break-words dark:!tw-text-gray-200 tw-font-semibold tw-m-2 tw-text-[13px] tw-whitespace-pre-line font-vazir-ui"
      [innerHtml]="fullText"
    ></p>
    }
  </div>
</div>
